import type { RouteRecordRaw } from 'vue-router';

export const authRouteNames = {
  login: 'login',
  signup: 'signup',
  logout: 'logout',
  collectBasicInfo: 'collect-basic-info',
  selectOrganization: 'select-organization',
  createOrganization: 'create-organization',
} as const;

export const authRouteNamesArray: readonly string[] = Object.values(authRouteNames);

export const authRoutes = [
  {
    path: 'login',
    redirect: (to) => ({ name: authRouteNames.login, query: to.query, hash: to.hash }),
  },
  {
    path: 'basic-info',
    name: authRouteNames.collectBasicInfo,
    component: () => import('./basic-info/BasicInfoPage.vue'),
    meta: { title: 'Basic info', requiresAuth: true },
  },
  {
    path: 'select-organization',
    name: authRouteNames.selectOrganization,
    component: () => import('./select-organization/SelectOrganizationPage.vue'),
    meta: {
      title: 'Select organization',
      requiresAuth: true,
      authLayoutVariant: 'workspace-selection',
    },
  },
  {
    path: 'create-organization',
    name: authRouteNames.createOrganization,
    component: () => import('./select-organization/CreateOrganizationPage.vue'),
    meta: { title: 'Apply for a New Account', requiresAuth: true, hasExtraMainPadding: true },
  },
] as const satisfies readonly RouteRecordRaw[];

export const loginRoute = {
  path: '/login',
  name: authRouteNames.login,
  component: () => import('./login/LoginRedirectPage.vue'),
  props: { flow: 'login' },
  meta: { title: 'Login', requiresAuth: false },
} as const satisfies RouteRecordRaw;

export const signupRoute = {
  path: '/signup',
  name: authRouteNames.signup,
  component: () => import('./login/LoginRedirectPage.vue'),
  props: { flow: 'signup' },
  meta: { title: 'Sign up', requiresAuth: false },
} as const satisfies RouteRecordRaw;

/**
 * Logout route - must be added at the root level (not under /auth)
 * because Auth0 redirects to /logout after logout.
 * This route is public and immediately redirects to login.
 */
export const logoutRoute = {
  path: '/logout',
  name: authRouteNames.logout,
  component: () => import('./logout/LogoutPage.vue'),
  meta: { requiresAuth: false },
} as const satisfies RouteRecordRaw;
